
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class SequenceSelectGrid extends _Ext.GridBase<SequenceRow, any> {
        protected getColumnsKey() { return 'Administration.Sequence'; }
        protected getDialogType() { return SequenceDialog; }
        protected getIdProperty() { return SequenceRow.idProperty; }
        protected getInsertPermission() { return SequenceRow.insertPermission; }
        protected getLocalTextPrefix() { return SequenceRow.localTextPrefix; }
        protected getService() { return SequenceService.baseUrl; }
        protected getInitialTitle() { return null; };

        constructor(container: JQuery, options) {
            super(container, options);
        }
    }
}